const messages = {
  step3: {
    actionBtn: "Log in",
  },
};

export default {
  messages,
};
